import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Signup from '../../components/organisms/Signup/Signup'
import ErrorPopup from '../../components/molecules/ErrorPopup/ErrorPopup'
import { FETCH_PROJECT } from '../../actions/projectActions'
import { getParams } from '../../../commons/utils'

class SignupPage extends PureComponent {
  componentDidMount() {
    const { fetchProject, imageUrl } = this.props
    if (imageUrl != null) {
      return
    }
    fetchProject(getParams())
  }

  render() {
    return (
      <div>
        {this.props.errorMessage ? <ErrorPopup /> : null}
        <Signup />
      </div>
    )
  }
}

SignupPage.propTypes = {
  // state
  imageUrl: PropTypes.string,
  errorMessage: PropTypes.string,
  // dispatch
  fetchProject: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  imageUrl: state.projects.imageUrl,
  errorMessage: state.notice.popupErrorMessage
})

const mapDispatchToProps = dispatch => ({
  fetchProject: params => dispatch(FETCH_PROJECT(params))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupPage)
